import styled from 'styled-components/macro';

// utils
import mq from '../../../utils/mediaQueriesBp';

// components & atoms
import ResponsiveContainer from '../../../components/layout/ResponsiveContainer';

const Wrapper = styled(ResponsiveContainer)`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin-top: 46px;
  margin-bottom: 60px;

  span {
    margin-bottom: 60px;
  }

  & > p {
    font-size: 16px;
    line-height: 22px;
    font-weight: 300;
    margin-bottom: 20px;
  }
  h4 {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0;
  }
  h5 {
    text-align: left;
    font-weight: 300;
    margin: 0;
    font-size: 16px;
  }
  p:last-child {
    font-size: 12px;
  }
  b {
    font-weight: bold;
  }
  a {
    display: block;
    color: #000;
    margin: 15px 0;
    text-transofrm: uppercase;
    font-weight: bold;
  }
  img {
    max-width: 800px;
    margin-bottom: 20px;
    object-fit: contain;
  }
  h2 {
    width: 100%;
    padding: 20px 20px;
    color: white;
    background: ${props => props.theme.colors.cyan};
    margin: 20px 0 20px 0;
    font-size: 24px;
    line-height: 30px;
    font-weight: 700;

    ${mq('tablet')} {
      font-size: 30px;
      line-height: 36px;
    }

    ${mq('desktop')} {
      margin: 40px 0 30px 0;
      padding: 20px 30px;
      font-size: 40px;
      line-height: 46px;
    }
  }

  h3 {
    width: 100%;
    font-size: 20px;
    line-height: 26px;
    font-weight: 700;
    margin: 0 0 20px 0;
  }

  ul {
    padding-left: 0;
  }
`;

const Outer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;

  & > :first-child {
    margin: 0 0 20px;
  }

  ${mq('desktop')} {
    flex-direction: row;

    & > :first-child {
      margin: 0 20px 0 0;
    }
  }
`;

const OuterReverse = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;

  & > :first-child {
    margin: 0 0 20px;
  }

  @media (max-width: 1024px) {
    flex-direction: column-reverse;
  }

  ${mq('desktop')} {
    flex-direction: row;

    & > :first-child {
      margin: 0 20px 0 0;
    }
  }
`;

const Outer2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
  background: #c6e2ff;
  padding: 50px 20px 50px 20px;

  & > :first-child {
    margin: 0 0 20px;

    @media (max-width: 1024px) {
      flex-direction: column;
    }
  }

  @media (max-width: 1024px) {
    flex-direction: column-reverse;
  }

  ${mq('desktop')} {
    flex-direction: row;

    & > :first-child {
      margin: 0 20px 0 0;
    }
  }
`;

const Outer2Reverse = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
  background: #c6e2ff;
  padding: 50px 20px 50px 20px;

  & > :first-child {
    margin: 0 0 20px;

    @media (max-width: 1024px) {
      flex-direction: column;
    }
  }

  @media (max-width: 1024px) {
    flex-direction: column-reverse;
  }

  ${mq('desktop')} {
    flex-direction: row-reverse;

    & > :first-child {
      margin: 0 0 0 20px;
    }
  }
`;

const Outer3 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
  background: #c6e2ff;
  padding: 50px 20px 50px 20px;

  & > :first-child {
    margin: 0 0 20px;
  }

  ${mq('desktop')} {
    flex-direction: row;

    & > :first-child {
      margin: 0 20px 0 0;
    }
  }
`;

const Inner = styled.div`
  width: 100%;

  & > p {
    margin-bottom: 20px;
  }
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: cover;

  float: left;
  margin: 0 50px 0 0;

  @media (max-width: 480px) {
    margin-right: 0;
    margin-bottom: 40px !important;
  }

  ${mq('desktop')} {
    max-height: 425px;
  }
`;

const BigImage = styled.img`
  float: right;
  margin: 5px 0 0 50px;
  max-height: 130px;

  ${mq('tablet')} {
    max-height: 250px;
  }
  ${mq('laptop')} {
    max-height: 350px;
  }

  ${mq('desktop')} {
    max-height: 440px;
  }

  @media (max-width: 1024px) {
    float: none;
    width: 100%;
    max-height: none;
    margin-right: 0;
  }
`;

const Before = styled.div`
  font-size: 18px;
  line-height: 22px;
  font-weight: 300;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 15px;

  @media (max-width: 1024px) {
    display: block;
  }

  a {
    color: black;
    margin-left: 3px;

    @media (max-width: 1024px) {
      margin-left: 0;
      display: inline;
    }
  }
`;
const WidgetOuter = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin: 20px 0 10px;
`;

const Download = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  a:nth-child(2) img {
    width: 180px;
  }

  ${mq('tablet')} {
    flex-direction: row;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  position: relative;
  width: 100%;
  margin-top: 20px;
  a {
    text-decoration: none;
  }

  button {
    max-width: 400px;
    font-size: 12px;
    ${mq('tablet')} {
      font-size: 18px;
    }
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const RowCustom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 480px) {
    flex-direction: column;
    a {
      margin: 0;

      > button {
        height: 70px;
      }
    }
  }
`;

const RowAllTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const CompendiumUls = styled.div`
  padding-left: 40px;
  padding-bottom: 25px;

  @media (max-width: 480px) {
    padding-left: 0;
  }
`;

const LeftText = styled.div``;

const StyledP = styled.p`
  margin-bottom: 15px;
  font-size: 18px;
`;

const MainP = styled.p`
  font-size: 18px;
  font-weight: 300;
`;

const MainPInline = styled.p`
  font-size: 18px;
  font-weight: 300;
  display: inline;
`;

const StyledLi = styled.li`
  font-size: 18px;
`;

const StyledH5 = styled.h5`
  font-style: italic;
`;

const IconItem = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background-color: ${p => p.theme.colors.primary};
  z-index: 1;
  transition: 0.3s ease-in-out;
  &:hover {
    opacity: 0.6;
  }
`;

const UnauthorizedContainer = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
`;

export {
  Wrapper,
  Outer,
  Inner,
  Image,
  BigImage,
  WidgetOuter,
  Download,
  ButtonContainer,
  Before,
  Row,
  CompendiumUls,
  LeftText,
  RowAllTop,
  StyledP,
  MainP,
  MainPInline,
  StyledLi,
  StyledH5,
  IconItem,
  Outer2,
  Outer2Reverse,
  Outer3,
  OuterReverse,
  UnauthorizedContainer,
  RowCustom,
};
